// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + "5f0afbea9dcb0fe80c7d" + ".chunk.js";
};